export default "__VITE_ASSET__xEJrZW2N__"